import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { AppRoutingModule } from './routing/app-routing.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { MonitorErroComponent } from './monitor/listagem/monitor-erro/monitor-erro.component';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { StatusLeituraPipe } from './pipes/status-leitura.pipe';
import { EmpresaListarComponent } from './empresa/listar/listar.component';
import { EditarComponent } from './empresa/id-empresa/editar/editar.component';
import { ReactiveFormsModule , FormsModule } from '@angular/forms';
import { RelatorioMapeamentoPorCidadesComponent } from './relatorio-mapeamento-por-cidades/relatorio-mapeamento-por-cidades.component';
import { MenuComponent } from './menu/menu.component';
import { AcompanhamentoDiarioDeMapeamentosComponent } from './acompanhamento-diario-de-mapeamentos/acompanhamento-diario-de-mapeamentos.component';
import { RelatorioArquivosPorEmpresaComponent } from './relatorio-arquivos-por-empresa/relatorio-arquivos-por-empresa.component';
import { RelatorioArquivosPendentesComponent } from './relatorio-arquivos-pendentes/relatorio-arquivos-pendentes.component';
import { ReprocessamentoComponent } from './reprocessamento/reprocessamento.component';
import { AplicativoCredenciamentoComponent } from './credenciamento/aplicativo/aplicativo-credenciamento.component';
import { CadastrarMunicipioEmpresaComponent } from './cadastrar-municipio-empresa/cadastrar-municipio-empresa.component';
import {LoaderComponent} from './loader/loader.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NovoCadastroComponent as CadastrarCredencialAplicativoModal } from './modal/credenciamento/aplicativo/novo-cadastro/novo-cadastro.component';
import { LoginComponent } from './login/login.component';
import {StorageServiceModule} from 'angular-webstorage-service';
import {TokenInterceptor} from './interceptors/token-interceptor';
import {JwtService} from './services/jwt.service';
import {LocalStorageService} from './services/local-storage.service';
import {MonitorClientesComponent} from './monitor-clientes/listar/monitor-clientes.component';
import { DetalhesModalComponent } from './monitor-clientes/listar/detalhes-modal/detalhes-modal.component';
import { MonitorPendenciasComponent } from './monitor/listagem/monitor-pendencias/monitor-pendencias.component';
import { ChartComponent } from './chart/generico/chart.component';
import { DashboardComponent } from './dashboard/generico/dashboard.component';
import { MonitorLinksComponent } from './monitor/listagem/monitor-links/monitor-links.component';
import { NgxSpinnerModule } from 'ngx-spinner';

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;


@NgModule({
  declarations: [
    AppComponent,
    MonitorErroComponent,
    MonitorPendenciasComponent,
    TimeAgoPipe,
    StatusLeituraPipe,
    EmpresaListarComponent,
    EditarComponent,
    RelatorioMapeamentoPorCidadesComponent,
    MenuComponent,
    AcompanhamentoDiarioDeMapeamentosComponent,
    RelatorioArquivosPorEmpresaComponent,
    RelatorioArquivosPendentesComponent,
    ReprocessamentoComponent,
    AplicativoCredenciamentoComponent,
    CadastrarCredencialAplicativoModal,
    LoginComponent,
    CadastrarMunicipioEmpresaComponent,
    LoaderComponent,
    MonitorClientesComponent,
    DetalhesModalComponent,
    ChartComponent,
    DashboardComponent,
    MonitorLinksComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StorageServiceModule,
    SnotifyModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    NgxSpinnerModule,
  ],
  providers: [
      {
          provide: 'SnotifyToastConfig',
          useValue: ToastDefaults
      },
      SnotifyService,
      {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true,
          deps: [JwtService, LocalStorageService]
      },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
